import { useCallback, useEffect, useRef } from 'react';

export function useAccountFetch(accountId) {
  const controller = useRef(new AbortController());
  useEffect(() => {
    const current = new AbortController();
    controller.current = current;
    return () => current.abort();
  }, [accountId]);
  return useCallback(async (url, options = {}) => {
    const current = controller.current;
    try {
      const response = await window.fetch(url, { credentials:'include', ...options, signal: current.signal });
      if (current.signal.aborted) throw new DOMException('Account changed', 'AbortError');
      return response;
    } catch (error) {
      if (current.signal.aborted) throw new DOMException('Account changed', 'AbortError');
      throw error;
    }
  }, []);
}

export function reportAccountFetchError(message, error) {
  if (error?.name !== 'AbortError' && error?.code !== 'ERR_CANCELED') console.error(message, error);
}